import { Injectable } from "@angular/core";
import { IAppConfig } from "../../models/app-config.model";
import { IAppMonitor } from "../../models/app-monitor.model";
import { environment } from "src/app/environments/environment";
import { APIService } from "../api.service";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { LocalDataService } from "../local-data.service";
export type AppArea = 'console' | 'appInsights' | 'logButtonClickEvents' | 'logServices' | 'logPipes' | 'logComponents' | 'logGridEvents' | 'interceptors' | 'commonAreas' | 'logAPIResponses' | 'logAPIRequests' | 'twilio';
@Injectable({
    providedIn: 'root'
})
export class AppConfigService {
    static settings: IAppConfig;
    static appMonitor: IAppMonitor;
    static currentUserData: any;

    constructor(private _apiService: APIService,
        private _localDataService: LocalDataService,
    ) {
        AppConfigService.currentUserData = this._localDataService.getLoginData('user');
    }

    load() {
        //const cacheBusterParam = (new Date()).getTime();
        const jsonFile = `assets/config/config.${environment.name}.json`//+cacheBusterParam;
        return new Promise<void>((resolve, reject) => {
            this._apiService.fetch(jsonFile)
                .subscribe({
                    next: (response) => {
                        AppConfigService.settings = <IAppConfig>response;
                        resolve();
                    },
                    error: (response: any) => {
                        reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
                    }
                });
        });
    }
    static trackEvent(appArea: AppArea, event: { name: string }, customProperties?: {
        [key: string]: any;
    }) {
        customProperties = AppConfigService.fillCurrentUserData(customProperties);
        if (AppConfigService.settings?.logging[appArea])
            AppConfigService.appMonitor.trackEvent(event, customProperties);
    }
    static trackPageView(appArea: AppArea, pageView: {
        name?: string;
        uri?: string;
        refUri?: string;
        pageType?: string;
        isLoggedIn?: boolean;
        properties?: {
            duration?: number;
            [key: string]: any;
        }
    }) {
        if (AppConfigService.settings?.logging[appArea])
            AppConfigService.appMonitor.trackPageView(pageView);

    }
    static trackPageViewPerformance(appArea: AppArea, pageViewPerformance: {
        name?: string;
        uri?: string;
        perfTotal?: string;
        duration?: string;
        networkConnect?: string;
        sentRequest?: string;
        receivedResponse?: string;
        domProcessing?: string;
    }) {
        if (AppConfigService.settings?.logging[appArea])
            AppConfigService.appMonitor.trackPageView(pageViewPerformance);
    }
    static trackException(appArea: AppArea, exception: { exception: Error, severityLevel?: SeverityLevel | number; }) {
        if (AppConfigService.settings?.logging[appArea])
            AppConfigService.appMonitor.trackException(exception);
    }
    static trackTrace(appArea: AppArea, trace: { message: string }, customProperties?: { [key: string]: any; }, severityLevel?: SeverityLevel) {
        if (AppConfigService.settings?.logging[appArea])
            AppConfigService.appMonitor.trackTrace(trace, customProperties, severityLevel);
    }
    static trackMetric(appArea: AppArea, metric: { name: string, average: number }, customProperties?: {
        [key: string]: any;
    }) {
        if (AppConfigService.settings?.logging[appArea])
            AppConfigService.appMonitor.trackMetric(metric, customProperties);
    }
    static fillCurrentUserData(customProperties?: { [key: string]: any; }) {
        if (customProperties)
            customProperties['userData'] = AppConfigService.currentUserData;
        else
            customProperties = { userData: AppConfigService.currentUserData };
        return customProperties;
    }
}